import Modal from "./Modal";

import ClientEditor from "../editors/ClientEditor";
import useBrowser from "../../hooks/useBrowser";

const ClientModal = ({ clientId, open, onClose, onSave }) => {
  const { windowHeight } = useBrowser();

  return (
    <Modal
      title={clientId ? "client_update" : "client_new"}
      open={open}
      onClose={onClose}
      height={`${windowHeight}px`}
    >
      <ClientEditor onSave={onSave} />
    </Modal>
  );
};

export default ClientModal;
